<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeClientStockRateDialog('ClientStockRateEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="ClientStockRate"
                    :rules="rules"
                    ref="ClientStockRateEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item label="关联客户" prop="client_id">
                            <el-select
                                v-model="ClientStockRate.client_id"
                                filterable
                                placeholder="选择客户"
                                class="clientc"
                                clearable
                            >
                                <el-option
                                    v-for="client in AllClient"
                                    :key="client.name"
                                    :label="client.name"
                                    :value="client.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="费率类型" prop="type">
                            <el-select
                                v-model="ClientStockRate.type"
                                placeholder="选择类型"
                                class="typec"
                                filterable
                                clearable
                            >
                                <el-option
                                    label="仓储费"
                                    :value=0
                                ></el-option>
                                <el-option
                                    label="仓储费(托盘)"
                                    :value=5
                                ></el-option>
                                <el-option
                                    label="仓租费"
                                    :value=1
                                ></el-option>
                                <el-option
                                    label="应收装卸费"
                                    :value=2
                                ></el-option>
                                <el-option
                                    label="应收装卸费(托盘)"
                                    :value=3
                                ></el-option>
                                <el-option
                                    label="应付装卸费"
                                    :value=4
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="费率" prop="rate">
                            <el-input-number
                                v-model="ClientStockRate.rate"
                                :min="0"
                                :step="1"
                                :precision="2"
                                :step-strictly="false"
                                size="small"
                                class="input_number"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item label="备注" prop="note">
                            <el-input type="textarea" :rows="5" v-model="ClientStockRate.note"></el-input>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>关联客户</span>
                                </template>
                                <span>{{ClientStockRate.client_name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>费率类型</span>
                                </template>
                                <span v-if="ClientStockRate.type === 0">仓储费</span>
                                <span v-else-if="ClientStockRate.type === 1">仓租费</span>
                                <span v-else-if="ClientStockRate.type === 2">应收装卸费</span>
                                <span v-else-if="ClientStockRate.type === 3">应收装卸费（托盘）</span>
                                <span v-else-if="ClientStockRate.type === 4">应付装卸费</span>
                                <span v-else></span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>费率</span>
                                </template>
                                <span>{{ClientStockRate.rate}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item :contentStyle="{'text-align':'left'}">
                                <template slot="label">
                                    <span>备注</span>
                                </template>
                                <span>{{ClientStockRate.note}}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="ClientStockRateDel('ClientStockRateEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeClientStockRateDialog('ClientStockRateEditForm')"
                        >关闭</el-button
                    >
                    <el-button
                        v-if="$_has(state_auth) && (ClientStockRate.state===1)"
                        type="success"
                        plain
                        round
                        @click="ClientStockRateState('ClientStockRateEditForm')"
                        >启用</el-button
                    >
                    <el-button
                        v-if="$_has(state_auth) && (ClientStockRate.state===0)"
                        type="danger"
                        plain
                        round
                        @click="ClientStockRateState('ClientStockRateEditForm')"
                        >禁用</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('ClientStockRateEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('ClientStockRateEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeClientStockRateDialog('ClientStockRateEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('ClientStockRateEditForm')"
                        >确定修改</el-button
                    >
                    <el-button plain @click="closeClientStockRateDialog('ClientStockRateEditForm')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { client_stock_rate_add_request,client_stock_rate_del_request,client_stock_rate_edit_request,client_stock_rate_state_request } from '@/network/business/ClientStockRate.js'

export default {
    name: 'ClientStockRateEditComponent',
    data() {
        return {
            login_loading: false,
            ClientStockRate: {
                client_id: '',
                client_name: '',
                type: '',
                rate: '',
                note: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入系统名称',
                        trigger: 'blur',
                    },
                    {
                        min: 2,
                        max: 16,
                        message: '长度在 2 到 16 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '费率详情'
            } else if (this.show_type === 1) {
                return '添加费率'
            } else {
                return '修改费率'
            }
        },
    },
    methods: {
        closeClientStockRateDialog(formName) {
            this.ClientStockRate.client_name = ''
            this.$refs[formName].resetFields()
            this.$emit('exitClientStockRateDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ClientStockRateInsert(formName)
            })
        },
        ClientStockRateInsert(formName) {
            this.login_loading = true
            client_stock_rate_add_request(this.ClientStockRate)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitClientStockRateDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ClientStockRateEdit(formName)
            })
        },
        ClientStockRateEdit(formName) {
            this.login_loading = true
            this.ClientStockRate.id = this.id
            client_stock_rate_edit_request(this.ClientStockRate)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitClientStockRateDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.ClientStockRate.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        ClientStockRateDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    client_stock_rate_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeClientStockRateDialog(formName))
                })
                .catch((err) => {})
        },
        ClientStockRateState(formName) {
            this.login_loading = true
            let obj = {}
            obj.id = this.id
            obj.state = this.ClientStockRate.state === 0 ? 1 : 0;
            client_stock_rate_state_request(obj)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        if(obj.state === 0) {
                            this.$message.success('启用成功!')
                        } else {
                            this.$message.success('禁用成功!')
                        }
                        this.$emit('exitClientStockRateDialog')
                        this.$emit('search')
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
                .finally(() => this.closeClientStockRateDialog(formName))
        },
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        client_stock_rate_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        AllClient: {
            type: Array,
            default() {
                return []
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: String,
        del_auth: String,
        state_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        client_stock_rate_details_data(newVal) {
            this.ClientStockRate = newVal
        },
    },
}
</script>

<style lang='less'>
.clientc {
    width: 100%;
}
.typec {
    width: 100%;
}
.input_number {
    width: 100%;
}
</style>